module.exports = __webpack_public_path__ + "img/background_color_white_computer_it_technologies.ce76c823.png";